import { render, staticRenderFns } from "./CommissionIndex.vue?vue&type=template&id=1850fd3a&scoped=true&"
import script from "./CommissionIndex.vue?vue&type=script&lang=js&"
export * from "./CommissionIndex.vue?vue&type=script&lang=js&"
import style0 from "./CommissionIndex.vue?vue&type=style&index=0&id=1850fd3a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1850fd3a",
  null
  
)

export default component.exports